import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// material-ui
import Select from '@mui/material/Select';

/* A drop-in MUI Select for the ST / OT Daily Activity sheets.
 *
 * MUI's menu is a fixed-position overlay placed once, when it opens. The page
 * scrolls inside an inner container rather than the window, so scrolling left the
 * open menu floating where it was, detached from its field (over Session Notes).
 * This one always drops straight below its field and closes as soon as anything
 * outside the menu scrolls - the way a native dropdown behaves. Scrolling INSIDE
 * the menu (a long option list) is left alone. */
const SheetSelect = ({ MenuProps, onOpen, onClose, ...props }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (e.target instanceof Element && e.target.closest('.MuiMenu-paper')) return;
      setOpen(false);
    };
    // Capture phase: scroll events do not bubble, and the scrolling element is
    // an ancestor container, not the window.
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [open]);

  return (
    <Select
      {...props}
      open={open}
      onOpen={(e) => {
        setOpen(true);
        onOpen?.(e);
      }}
      onClose={(e) => {
        setOpen(false);
        onClose?.(e);
      }}
      MenuProps={{
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        // The page keeps scrolling normally; the scroll closes the menu instead.
        disableScrollLock: true,
        ...MenuProps,
        slotProps: {
          ...MenuProps?.slotProps,
          paper: { ...MenuProps?.slotProps?.paper, sx: { mt: 0.5, maxHeight: 320, ...MenuProps?.slotProps?.paper?.sx } }
        }
      }}
    />
  );
};

SheetSelect.propTypes = {
  MenuProps: PropTypes.object,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};

export default SheetSelect;
